import { useQuery } from '@tanstack/react-query';
import { advanceApplicationsQueryKey } from './keys';
import { normalizeAdvanceApplication } from '../types';
import type {
  AdvancesHttpRequest,
  DocumentAdvanceApplicationDto,
  RawDocumentAdvanceApplicationDto,
} from '../types';

export interface UseDocumentAdvanceApplicationsParams {
  documentId: string;
  /** Endpoint GET de aplicaciones del documento (`/documents/{id}/advances`). */
  applicationsEndpoint: string;
  httpRequest: AdvancesHttpRequest;
  enabled?: boolean;
}

/**
 * Lista las aplicaciones de anticipo del documento (lo que el panel renderiza).
 *
 * Cache key: `['advance-applications', documentId]`.
 * Normaliza el `status` (int o string) del backend a la unión del widget.
 */
export function useDocumentAdvanceApplications({
  documentId,
  applicationsEndpoint,
  httpRequest,
  enabled = true,
}: UseDocumentAdvanceApplicationsParams) {
  return useQuery<DocumentAdvanceApplicationDto[]>({
    queryKey: advanceApplicationsQueryKey(documentId),
    enabled: enabled && Boolean(documentId),
    queryFn: async () => {
      const raw = await httpRequest<RawDocumentAdvanceApplicationDto[]>('GET', applicationsEndpoint);
      return (raw ?? []).map(normalizeAdvanceApplication);
    },
  });
}
